import React from "react";

const ScrollSkeleton = () => {
  return (
    <div className="flex flex-col items-center gap-2 p-4">
      <div className="flex w-full justify-center gap-10">
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
      </div>
      <div className="flex w-full justify-center gap-10">
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
      </div>

      <div className="flex w-full justify-center gap-10 border-y-2 border-purple-300 py-2">
        <div className="h-6 w-12 animate-pulse rounded bg-purple-200"></div>
        <div className="h-6 w-12 animate-pulse rounded bg-purple-200"></div>
      </div>

      <div className="flex w-full justify-center gap-10">
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
      </div>
      <div className="flex w-full justify-center gap-10">
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
        <div className="h-6 w-12 animate-pulse rounded bg-gray-300"></div>
      </div>
    </div>
  );
};

export default ScrollSkeleton;
